import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`BorderBox is a Box component with a border. When no `}<inlineCode parentName="p">{`borderColor`}</inlineCode>{` is present, the component defaults to a primary border.`}</p>
    <h2>{`Deprecation`}</h2>
    <p>{`Use `}<a parentName="p" {...{
        "href": "/Box"
      }}>{`Box`}</a>{` instead.`}</p>
    <p><strong parentName="p">{`Before`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "deprecated",
        "deprecated": true
      }}>{`<BorderBox>Item 1</BorderBox>
`}</code></pre>
    <p><strong parentName="p">{`After`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "deprecated",
        "deprecated": true
      }}>{`<Box borderWidth="1px" borderStyle="solid" borderColor="border.default" borderRadius={2}>
  Item 1
</Box>
`}</code></pre>
    <h2>{`Default example`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<BorderBox>This is a BorderBox</BorderBox>
`}</code></pre>
    <p>{`Note that `}<inlineCode parentName="p">{`BorderBox`}</inlineCode>{` has default props set for `}<inlineCode parentName="p">{`borderWidth`}</inlineCode>{`, `}<inlineCode parentName="p">{`borderStyle`}</inlineCode>{`, and `}<inlineCode parentName="p">{`borderColor`}</inlineCode>{`. This means that you cannot use `}<inlineCode parentName="p">{`border={0} borderBottom={1}`}</inlineCode>{` or similar patterns; instead, use individual properties like `}<inlineCode parentName="p">{`borderWidth={0} borderBottomWidth={1}`}</inlineCode>{`.`}</p>
    <h2>{`System props`}</h2>
    <p>{`BorderBox components get `}<inlineCode parentName="p">{`COMMON`}</inlineCode>{`, `}<inlineCode parentName="p">{`LAYOUT`}</inlineCode>{`, `}<inlineCode parentName="p">{`BORDER`}</inlineCode>{`, and `}<inlineCode parentName="p">{`FLEX`}</inlineCode>{` system props. Read our `}<a parentName="p" {...{
        "href": "/system-props"
      }}>{`System Props`}</a>{` doc page for a full list of available props.`}</p>
    <h2>{`Component props`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Prop name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`borderWidth`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`'1px'`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets the border, use theme values or provide your own.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`borderStyle`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`'solid'`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets the border style, use theme values or provide your own.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`borderColor`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`'border.primary' (from theme)`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets the border color, use theme values or provide your own.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`borderRadius`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String or Number`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2 (from theme)`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets the border radius, use theme values or provide your own.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`boxShadow`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets box shadow, use theme values or provide your own.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      